import { escapeCSV } from '@root/utils/Export';

const getCsvContent = (docs) => docs.reduce((csv, doc) => {
  const title = doc.content[0];
  const body = doc.content[1];
  return `${csv}"${escapeCSV(title?.trim())}","${escapeCSV(
    body?.trim(),
  )}"\r\n`;
}, '');

const getPdfContent = (docs) => docs.reduce((pdf, doc) => {
  const title = doc.content[0];
  const body = doc.content[1];

  return `${pdf}\n\n${title?.trim()}\n${body?.trim()}\r\n`;
}, '');

const getTxtContent = (docs) => docs.reduce((txt, doc) => {
  const title = doc.content[0];
  const body = doc.content[1];

  return `${txt}\n\n${title?.trim()}\n${body?.trim()}\r\n`;
}, '');

const encodeStr = (rawStr) => rawStr.replace(/[\u00A0-\u9999<>&]/gim, (i) => `&#${i.charCodeAt(0)};`);

const stringifyContent = (templateContent) => {
  let title = '';
  let description = '';
  if (templateContent.length >= 2) {
    title = templateContent[0] || '';
    description = templateContent[1] || '';
  }

  return `${title}
${description}
<title>${encodeStr(title)}</title>
<meta name="description" content="${encodeStr(description)}">`;
};

const getClipboardItem = (doc) => stringifyContent(doc.content);

export default { getPdfContent, getTxtContent, getCsvContent, getClipboardItem, stringifyContent };
